export enum OrderStatusEnum {
	NOT_FULFILLED = 'NOT_FULFILLED',
	CANCELED = 'CANCELED',
	FULFILLED = 'FULFILLED',
}
